import { useState } from 'react'
import { Button, Typography, Dialog, useTheme } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'services/amplitudeTracking'
export const rolePlayLink = 'https://leadwithmonark.com/aire-practice'

const SharePublicRolePlayButton = ({
  label,
  variant = 'outlined',
  btnSx = {},
  trackLocation,
  handleClickCallback = () => {}
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [linkCopied, setLinkCopied] = useState(false)

  const copyLink = () => {
    navigator.clipboard.writeText(rolePlayLink)
    setLinkCopied(true)
    trackEvent('Share Practice', { location: trackLocation })
  }

  return (
    <>
      <Button variant={variant} onClick={copyLink} sx={btnSx}>
        {label ?? t('publicRolePlay.shareAirePractice')}
      </Button>

      {/* Success Dialog */}
      <Dialog open={linkCopied} sx={theme.publicRolePlay.result.thanksDialog}>
        <InCardStack spacing={16}>
          <InCardStack spacing={0} textAlign={'center'}>
            <Typography sx={theme.publicRolePlay.result.heading}>
              {t('fullReport.linkCopied')}
            </Typography>

            <InCardStack spacing={8} textAlign={'center'}>
              <Typography variant='h4' fontWeight={400}>
                {t('publicRolePlay.linkHasBeenCopied')}
              </Typography>
              <Typography variant='h4' fontWeight={400}>
                {t('publicRolePlay.orCopyLinkBelow')}
              </Typography>
              <Typography variant='h4' fontWeight={400}>
                {rolePlayLink}
              </Typography>
            </InCardStack>
          </InCardStack>

          <Button
            onClick={() => {
              setLinkCopied(false)
              handleClickCallback()
            }}>
            {t('common.done')}
          </Button>
        </InCardStack>
      </Dialog>
    </>
  )
}

export default SharePublicRolePlayButton
